// Permission selects the capability; scope is evaluated separately by the backend.
// Main Church routes use church-wide capabilities. Scoped workspaces authorize
// their own selected ministry through the existing context endpoints.
export function pagePermission(path: string): string | undefined {
  path = path.replace(/\/+$/, "") || "/";
  if (path === "/") return undefined;
  if (/^\/members(?:\/|$)/.test(path)) return "MEMBERS_VIEW";
  if (/^\/households(?:\/|$)/.test(path)) return "HOUSEHOLDS_VIEW";
  if (path === "/services") return "SERVICES_VIEW";
  if (path === "/attendance") return "ATTENDANCE_VIEW";
  if (path === "/care-queue") return "CARE_VIEW";
  if (/^\/reports(?:\/|$)/.test(path)) return "REPORTS_VIEW";
  if (path === "/intelligence") return "INTELLIGENCE_VIEW";
  // These administrative endpoints retain their existing backend requirements.
  if (path === "/settings/data-import") return "DATA_IMPORT_MANAGE";
  if (path === "/settings/system-health") return "SETTINGS_MANAGE";
  if (path === "/settings/administration/ministries") return "MINISTRIES_MANAGE";
  if (/^\/settings\/administration\/(roles|assignments)$/.test(path)) return "ROLES_MANAGE";
}

export function canOpenPage(path: string, permissions: Set<string>) {
  if (path.replace(/\/+$/, "") === "/settings/data-import") return permissions.has("DATA_IMPORT_MANAGE") && permissions.has("MEMBERS_MANAGE");
  const permission = pagePermission(path);
  return !permission || permissions.has(permission);
}
